import { useSelector } from "react-redux";
import { getCurrentItem } from "../../reducers/playbackState";
import { Card, CardMedia, Typography } from "@mui/material";
import { simplifyPlayableSingleItem } from "../../utils/spotifyUtils";
import CarouselText from "../common/text/CarouselText";
import { clearingQueueRunning } from "../../reducers/disablingProcesses";
import { useViewport } from "../../hooks/others/useViewport";
import { PLAYBACK_INFO_CARD_HEIGHT, PLAYBACK_INFO_CAROUSEL_TEXT_MAX_WIDTH, PLAYBACK_INFO_CONTENT_FLEX_GROW, PLAYBACK_INFO_CONTENT_MAX_WIDTH } from "../../utils/constants/viewConstants";

const PlaybackInfo = () => {
    const cardHeight = useViewport(PLAYBACK_INFO_CARD_HEIGHT);
    const contentMaxWidth = useViewport(PLAYBACK_INFO_CONTENT_MAX_WIDTH);
    const carouselTextMaxWidth = useViewport(PLAYBACK_INFO_CAROUSEL_TEXT_MAX_WIDTH) * 16;
    const contentFlexGrow = useViewport(PLAYBACK_INFO_CONTENT_FLEX_GROW);

    const currentTrack = simplifyPlayableSingleItem(useSelector(getCurrentItem));
    const clearingQueue = useSelector(clearingQueueRunning);

    const showPlaceholder = clearingQueue || !currentTrack;

    const TrackName = () => {
        return (
            <CarouselText maxWidth={carouselTextMaxWidth}>
                <Typography variant="body2">{showPlaceholder ? "Unknown track" : currentTrack.name}</Typography>
            </CarouselText>
        )
    }

    const Artists = () => {
        const artistText = showPlaceholder ? "Unknown artist" : currentTrack.artists.join(', ');

        return (
            <CarouselText maxWidth={carouselTextMaxWidth}>
                <Typography variant="body2">{artistText}</Typography>
            </CarouselText>
        );
    }

    return (
        <div className="d-flex flex-row ai-center" style={{ height: cardHeight }}>
            <Card sx={{width: 'fit-content', height: 'fit-content'}}>
                {
                    showPlaceholder ?
                    <div style={{minWidth: cardHeight, minHeight: cardHeight}} /> :
                    <CardMedia image={currentTrack.images.md.url} sx={{ minWidth: cardHeight, minHeight: cardHeight }} />
                }
            </Card>
            <div className="d-flex flex-column jc-space-between p-0_25" style={{ width: contentMaxWidth, flexGrow: contentFlexGrow }}>
                <TrackName />
                <Artists />
            </div>
        </div>
    )
}

export default PlaybackInfo;